
import Vue from 'vue'
import Component from 'vue-class-component'

@Component
export default class Header extends Vue {
    search = ''
    searchTimer: number | null = null

    toggleNav(){
        this.$store.commit('setSideNav')
    }

    scheduleSearch () {
        const query = this.search.trim()
        this.clearSearchTimer()

        if (query.length < 3) {
            return
        }

        this.searchTimer = window.setTimeout(() => {
            this.searchTimer = null
            this.navigateToSearch(query)
        }, 600)
    }

    runSearchNow () {
        const query = this.search.trim()
        this.clearSearchTimer()

        if (query.length < 2) {
            return
        }

        this.navigateToSearch(query)
    }

    navigateToSearch (query: string) {
        const path = '/search/' + encodeURIComponent(query)
        if (this.$route.path !== path) {
            this.$router.push(path)
        }
    }

    clearSearchTimer () {
        if (this.searchTimer === null) {
            return
        }
        window.clearTimeout(this.searchTimer)
        this.searchTimer = null
    }

    beforeDestroy () {
        this.clearSearchTimer()
    }
}
